export default __webpack_public_path__ + "static/media/crees3.c8d0fec9.jpg";